import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import {BoxButton, MainHeading } from '../../StyledComponents';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import SentimentFiltering from './SentimentFiltering';

/**
* styled components
*/
const SuggestionsContainer = styled.div`
  h2 {
    text-transform: uppercase;
    margin-top:0;
  }
`;

const ObservationContainer = styled.div`
  p {
    margin-bottom: 0;
  }
`;

const TagSuggestions = styled.div``;

const TagSuggestion = styled.span`
  display: block;
  margin-top: 5px;
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 18px;

  &:nth-child(1) {
    color: #0e67ba;
  }

  &:nth-child(2) {
    color: #d9a8e4;
  }

  &:nth-child(3) {
    color:#d06768;
  }

  &.report-tag {
    display: inline-block;
    font-size: 9px;
  }
`;

const EditButton = styled(BoxButton) `
  min-width:30px;
  float:right;
`;

const modalStyleOpenDialog = {
  maxWidth: '700px',
}

/**
* Class Suggestions
*/
class Solutions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editDialogOpen: false,
    };
  }

  handleCloseEditDialog = () => {
    this.setState({editDialogOpen: false});
  };

  renderObservation(data) {
    if (!data) {
      return null;
    }

    if (this.props.parameter) {
      return (
        <ObservationContainer>
          <p className="small-font-size" style={{maxWidth:'300px', marginBottom:'20px'}}>To improve the brand status within {data.observation.property} you should focus on:</p>
        </ObservationContainer>
      )
    }

    if (this.props.primaryText) {
      return (
        <ObservationContainer>
          <p className="small-font-size" style={{'maxWidth':'300px'}}>{this.props.primaryText}</p>
          {this.renderSuggestions(data.suggestions.property)}
        </ObservationContainer>
      )
    } else {
      return (
        <ObservationContainer>
          <p className="small-font-size" >From analysing the key outakes from <span className="report-tag tiny-font-size">{data.observation.property}</span> we should work on the following areas:</p>
          {/*this.renderSuggestions(data.suggestions.property)*/}
        </ObservationContainer>
      )
    }
  }

  renderSuggestions(suggestions) {
    return(

      <TagSuggestions>
      {
        _.map(suggestions, (suggestion, index) => {
          return(
            <TagSuggestion key={`suggestiontag-${suggestion}-${index}`} className="tiny-font-size report-tag">{suggestion}</TagSuggestion>
          );
        })
      }
      </TagSuggestions>

    )
  }

  getHighestImpactP(dp, allDps) {
    const telescope = this.props.data.telescope;
    const highestImpact = -1000;
    let highestImpactP = {};
    if (!dp) {
      return null;
    }

    allDps.forEach(p => {
      if (dp.id !== "total" && p.id !== "total" && dp.id !== p.id) {
        const input = {};
        input[dp.apiId] = 1;

        if (dp.apiId && !isNaN(dp.score)) {
          const predictions = telescope.predict(input);
          const coeff = predictions[p.apiId];
          if (coeff && coeff > highestImpact) {
            highestImpactP = p;
          }
        }
      }
    });

    if (dp.id === "total") {
      return false;
    }

    return highestImpactP.name || null;
  }

  recommendedActivities(recommendation) {
    let activities = [];
    const property = recommendation && recommendation.observation && recommendation.observation.property && recommendation.observation.property.toLowerCase();

    const sentimentSettings = this.props.user.client && this.props.user.client.sentimentSettings;

    let paramSentiment = _.filter(sentimentSettings, function(row, i) {
      return row[0].value === property;
    })

    let recommendationWords = [];
    _.each(paramSentiment, function(col, i) {
      _.each(col, function(item,i) {
        if (item.type === "keyword" && recommendationWords.indexOf(item.value) === -1) {
          recommendationWords.push(item.value);
        }
      })
    })

    return (
      <TagSuggestions>
      {
        _.map(recommendationWords, (activity, index) => {
          return(
            <TagSuggestion key={`suggestiontag-${activity}-${index}`}>{activity}</TagSuggestion>
          );
        })
      }
      </TagSuggestions>
    )
  }

  buildRecommendation(data) {
    let highestPotentialVar;
    let highestPotentialScore = -10000;

    if (!data.variableData || !data.variableData.variables.length) {
      return null;
    }

    // Find P with highest potential
    data && data.variableData && data.variableData.variables.forEach(v => {
      if (v.potential > highestPotentialScore) {
        highestPotentialScore = v.potential;
        highestPotentialVar = v;
      }
    });

    let parameter = highestPotentialVar && highestPotentialVar.name;

    if (this.props.parameter) {
      parameter = this.props.parameter
    }

    let recommendation = {
      "title": "solutions",
      "observation": {
        "property": parameter
      },
      "suggestions": {
        "property": [
          this.getHighestImpactP(highestPotentialVar, data.variableData.variables)
        ]
      }
    };
    return recommendation;
  }

  render() {
    const { data, user } = this.props;
    const recommendation = this.buildRecommendation(data);

    const editDialogActions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleCloseEditDialog}
        key="cancel"
      />
    ];

    return(
      <SuggestionsContainer>
        {user.userProfile && user.userProfile.isAdmin && (
          <EditButton
            onClick={() => this.setState({editDialogOpen: !this.state.editDialogOpen})}
            className="margin-right hidden-xs"
          >
              <span>&#9776;</span>
          </EditButton>
        )||null}

        <MainHeading style={{marginBottom:'20px'}}>{this.props.title || "Suggested solutions"}</MainHeading>

        {this.renderObservation(recommendation)}

        {/* <Divider/> */}

        {this.props.secondaryText ? <p className="small-font-size" style={{'marginTop':'10px'}}>{this.props.secondaryText}</p>:null}
        {this.recommendedActivities(recommendation)}

        <Dialog
          title="Sentiment"
          modal={false}
          open={this.state.editDialogOpen}
          onRequestClose={this.handleCloseEditDialog}
          contentStyle={modalStyleOpenDialog}
        >
          <SentimentFiltering/>
          <div style={{ textAlign: 'right', padding: 8, margin: '24px -24px -24px -24px' }}>
            {editDialogActions}
          </div>
        </Dialog>
      </SuggestionsContainer>
    );
  }
}


function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid,
        data: state.data,
        user: state.user
    };
}

export default connect(mapStateToProps)(Solutions);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/Solutions.js